import { Table, Checkbox } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { RoomForSpeakingSessionDto } from 'api/planning';
import { SpeakingTypeBadge } from 'components';
import { RoomReservedInfo } from './RoomResrvedInfo';

type Props = {
  room: RoomForSpeakingSessionDto;
  onChange: (checked: boolean) => void;
  checked: boolean;
};

export const AvailableRoom = ({ room, onChange, checked }: Props) => {
  const isRoomReserved = room.roomReservations.length > 0;

  return (
    <Table.Row data-testid={`available-room-row-speaking-${room.id}`}>
      <Table.Cell>
        <S.Centered>
          <Checkbox onChange={() => onChange(!checked)} data-testid="room-selection-checkbox-speaking" />
        </S.Centered>
      </Table.Cell>
      <Table.Cell>
        <S.Centered>
          {isRoomReserved && <RoomReservedInfo reservations={room.roomReservations} />}
        </S.Centered>
      </Table.Cell>
      <Table.Cell data-testid="room-building-cell-speaking">{room.building}</Table.Cell>
      <Table.Cell data-testid="room-floor-cell-speaking">{room.floor}</Table.Cell>
      <Table.Cell data-testid="room-name-cell-speaking">{room.name}</Table.Cell>
      <Table.Cell data-testid="room-properties-cell-speaking">
        {room.availableSpeakingSlotTypes?.map((type) => (
          <SpeakingTypeBadge speakingSlotType={type} key={type} />
        ))}
      </Table.Cell>
    </Table.Row>
  );
};

const S = {
  Centered: styled.div`
    display: flex;
    justify-content: center;
  `,
};
